import { configureStore } from "@/lib/store"

interface SoundAlertState {
  // Plays a chime when a conversation needs attention in the Pendentes tab.
  soundAlertEnabled: boolean
}

export const soundAlertStore = configureStore<SoundAlertState>(
  () => ({
    soundAlertEnabled: true,
  }),
  {
    persistOptions: {
      name: "chat-sound-alert-storage",
    },
  }
)

export function setSoundAlertEnabled(soundAlertEnabled: boolean): void {
  soundAlertStore.setState({ soundAlertEnabled })
}
